// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productActionsStyle } from "@conklin/App/Components/Product/ProductActions";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productActionsStyle.addToCartContainer = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        flex-wrap: wrap;
        min-width: 237px;
        ${xScreen("lte", "md")} {
            min-width: unset;
        }
    `,
};

productActionsStyle.addToCartButtonWrapper = {
    css: css`
        flex-grow: 1;
        min-width: 100px;
        &:empty {
            display: none;
        }
    `,
};

productActionsStyle.qtyWrapper = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};

productActionsStyle.productUnitOfMeasureSelectStyles = {
    mergeCss: true,
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            width: 92px;
        `,
    },
};

productActionsStyle.productAddToCartButtonStyles = {
    mergeCss: true,
    sizeVariant: "small",
    css: css`
        white-space: nowrap;
        width: 100%;
    `,
};
